<template>
  <div class="col-md-12 default">
    <system-info />
  </div>
</template>

<script>
import systemInfo from "./SystemInfo.vue";

export default {
  components: {
   systemInfo
  },
  props: ["type"],
  data() {
    return {
      
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },

  methods: {
   
  },
};
</script>
